/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  Subregions,
  SubregionsVariables,
  Subregions_subregions_Subregions_results_Subregion as Subregion,
} from './types/index.graphql'

export const SUBREGIONS = gql`
  query Subregions($regionId: Int!) {
    subregions(regionId: $regionId) {
      results {
        id
        name
        location {
          coordinates
          type
        }
      }
    }
  }
`
